import { SensorGeneration } from "enums/Sensor";
import Dropdown from "components/Dropdowns/Dropdown/Dropdown";
import { IDropdownOption } from "interfaces/Common";

interface SensorGenerationFilterProps {
  selected: SensorGeneration | undefined;
  onChange: (value: SensorGeneration | undefined) => void;
}

const ANY_GENERATION_VALUE = -2; // Use -2 to avoid conflict with MenuOption.Unselected (-1)

const OPTIONS: IDropdownOption<number>[] = [
  { value: ANY_GENERATION_VALUE, label: "All" },
  { value: SensorGeneration.Gen3, label: "Gen 3" },
  { value: SensorGeneration.Gen4, label: "Gen 4" },
];

const SensorGenerationFilter = ({
  selected,
  onChange,
}: SensorGenerationFilterProps) => (
  <div className="w-40">
    <Dropdown
      hideClearButton
      label="Generation"
      options={OPTIONS}
      selected={selected ?? ANY_GENERATION_VALUE}
      onChange={(value) =>
        onChange(
          value === ANY_GENERATION_VALUE
            ? undefined
            : (value as SensorGeneration)
        )
      }
    />
  </div>
);

export default SensorGenerationFilter;
